/* eslint-disable max-len */
import FileSaver from 'file-saver';
import { captureException } from '@playbookux/playbook-web-core';
import client from './client';

// eslint-disable-next-line consistent-return
const exportProject = async (projectId, type, projectName, autoDownload = true) => {
  try {
    const response = await client.get('export', {
      responseType: 'blob',
      headers: { 'Key-Inflection': 'camel' },
      params: { id: projectId, report_type: type },
    });
    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    if (autoDownload) {
      FileSaver.saveAs(blob, `${projectName || type}.xlsx`);
    } else {
      const blobInfo = {
        blob,
        fileName: projectName || type,
      };

      return blobInfo;
    }
  } catch (error) {
    captureException('EXPORT_PROJECT_FAILED', error);
    throw error;
  }
};

export const downloadExportProject = async (exportInfo) => {
  try {
    if (!exportInfo) {
      throw new Error('EXPORT_INFO_UNDEFINED');
    }

    const { blob, fileName } = exportInfo;
    FileSaver.saveAs(blob, `${fileName}.xlsx`);
  } catch (error) {
    captureException('EXPORT_PROJECT_FAILED', error);
    throw error;
  }
};

export const exportUploadProject = (projectId, autoDownload) => exportProject(projectId, 'upload_testers', null, autoDownload);

export const exportModeratedProject = (projectId, autoDownload) => exportProject(projectId, 'moderated_testers', null, autoDownload);

export const exportUnmoderatedProject = (projectId, autoDownload) => exportProject(projectId, 'unmoderated_testers', null, autoDownload);

export const exportCardSort = (projectId, autoDownload) => exportProject(projectId, 'card_sort_testers', null, autoDownload);

export const exportTreeTest = (projectId, projectName, autoDownload) => exportProject(projectId, 'tree_test_testers', projectName, autoDownload);

// TODO: check with Kristen to have the have answer from Carbone,
// because sometimes when we make request to Carbone the template is found or not.
// it is only for survey, other types are ok.
export const exportSurveyProject = (projectId, projectName, autoDownload) => exportProject(projectId, 'survey_testers', projectName, autoDownload);

export const exportUsage = (companyId, autoDownload) => exportProject(companyId, 'usage', null, autoDownload);

export const exportSegmentData = (segmentId, autoDownload, fileName) => exportProject(segmentId, 'segment_data', fileName, autoDownload);
